// Flow 15 — student's own plan, Flow 16 — plan the week, Flow 17 — reminders (simulated SMS until lot 4).
export const FLOW15_TITLE = "Flow 15 — Mon plan d’étude (élève)";
export const FLOW15_STEPS = ["Quoi pratiquer", "Récapitulatif", "Plan créé"];

export const FLOW16_TITLE = "Flow 16 — Planifier ma semaine";
export const FLOW16_STEPS = ["Séances à placer", "Semaine planifiée"];

export const FLOW17_TITLE = "Flow 17 — Rappels et séance du jour";
export const FLOW17_STEPS = ["Rappel à l’heure prévue", "Rappels +1 h et +3 h", "Séance commencée"];

export const REMINDER_OFFSETS = [0, 60, 180];
export const QUIET_HOURS = [8, 21];
export const FALLBACK_TIME = "16:00";

const W = (key, step, label, prompt, text) => ({ key, flowId: 16, step, label, prompt, text });
const R = (key, step, label, prompt, text) => ({ key, flowId: 17, step, label, prompt, text });

export const WEEK_MESSAGES = [
  W("w.alreadyPlanned", 0, "Semaine déjà placée", "Toutes les séances sont déjà placées : pas besoin de reprendre l'explication.", () =>
    "Ta semaine est déjà planifiée : voici tes séances."),
  W("w.proposeAuto", 0, "Semaine proposée", "Flow 4 : disponibilités déjà connues, la semaine est proposée directement. « Modifier » ouvre la carte manuelle.", () =>
    "Voici ta semaine proposée selon tes disponibilités. Tu peux la confirmer ou la modifier."),
  W("w.planWeek", 0, "Planifier la semaine", "À chaque accueil, s'il reste des séances à placer : un jour et une heure par séance (pas de 20 min).", () =>
    "Planifions ta semaine 📅 Choisis un jour et une heure pour chaque séance. Je te rappelle au bon moment."),
  W("w.weekDone", 1, "Semaine planifiée", "Toutes les séances de la semaine ont un jour et une heure.", () =>
    "Ta semaine est planifiée ✅ Je t’envoie un rappel à l’heure de chaque séance."),
  W("w.weekPartial", 1, "Semaine en partie planifiée", "L'élève ferme la planification avant d'avoir tout placé.", () =>
    "C’est noté. Il reste des séances à placer : je te le redemanderai au prochain accueil."),
  R("w.sms1", 0, "Texto : rappel 1", "Texto à l'heure prévue de la séance (ou 16 h pour le plan prioritaire).", (ctx) =>
    `Plan Étude : c’est l’heure de ta séance « ${ctx.title || "ton plan d’étude"} ». Commence ici : ${ctx.link || ""}`),
  R("w.sms2", 1, "Texto : rappel 2 (+1 h)", "Seulement si la séance n'est pas commencée.", (ctx) =>
    `Plan Étude : ta séance « ${ctx.title || "ton plan d’étude"} » t’attend. Commence ici : ${ctx.link || ""}`),
  R("w.sms3", 1, "Texto : rappel 3 (+3 h)", "Dernier rappel du jour, seulement si la séance n'est pas commencée.", (ctx) =>
    `Plan Étude : dernier rappel pour aujourd’hui, « ${ctx.title || "ton plan d’étude"} ». ${ctx.link || ""}`),
  R("w.sessionNow", 2, "Séance commencée", "L'élève a ouvert le lien du rappel : la séance commence.", (ctx) =>
    `C’est parti pour « ${ctx.title || "ta séance"} » 💪 Quand tu as fini, indique ce que tu as fait.`),
];
